(function () {
  'use strict';
  function identity(item) {
    var properties = item.properties || {};
    return JSON.stringify([String(item.variant_id || item.id), Object.keys(properties).sort().map(function (key) { return [key, properties[key]]; }), item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.id : null]);
  }
  function inspect(cart, config) {
    var eligible = new Set(config.eligibleVariants.map(String));
    var gifts = cart.items.filter(function (item) { return String(item.variant_id || item.id) === String(config.giftVariant) && (item.properties || {})[config.markerKey] === config.markerValue; });
    return { gifts: gifts, qualified: cart.items.some(function (item) { return item.quantity > 0 && eligible.has(String(item.variant_id || item.id)); }) };
  }
  function fingerprint(cart, config) {
    var gifts = inspect(cart, config).gifts;
    return JSON.stringify(cart.items.filter(function (item) { return gifts.indexOf(item) === -1; }).map(function (item) { return [identity(item), item.quantity]; }).sort());
  }
  function giftCovered(cart, config, gift) {
    var required = Number(gift.original_price);
    if (!Number.isSafeInteger(required) || required <= 0) return false;
    var covered = 0;
    cart.items.forEach(function (item) {
      if (String(item.variant_id || item.id) !== String(config.giftVariant)) return;
      (Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : []).forEach(function (allocation) {
        var application = allocation.discount_application || {};
        var amount = Number(allocation.amount);
        if (application.type === 'discount_code' && String(application.title).toUpperCase() === 'FREEPERK' && Number.isSafeInteger(amount) && amount > 0) covered += amount;
      });
    });
    return Number.isSafeInteger(covered) && covered >= required;
  }
  function plan(cart, config, state) {
    var view = inspect(cart, config);
    if ((!view.qualified || state.declined) && view.gifts.length) return { type: 'change', item: view.gifts[0], quantity: 0 };
    if (view.gifts.length > 1) return { type: 'change', item: view.gifts[view.gifts.length - 1], quantity: 0 };
    if (view.gifts.length && view.gifts[0].quantity > 1) return { type: 'change', item: view.gifts[0], quantity: 1 };
    if (view.gifts.length && !giftCovered(cart, config, view.gifts[0])) return { type: 'reject', item: view.gifts[0], quantity: 0 };
    if (state.active && !state.declined && view.qualified && !view.gifts.length && state.blocked !== fingerprint(cart, config)) return { type: 'add' };
    return null;
  }
  function createEngine(config, io, state) {
    var tail = Promise.resolve();
    var remembered = new Map();
    var current = null;
    var giftOutcomeUnknown = !!config.hasGift;
    async function read() {
      var next = await io.read();
      if (!next || !Array.isArray(next.items)) throw new Error('Invalid cart response');
      current = next;
      giftOutcomeUnknown = false;
      current.items.forEach(function (item) { remembered.set(item.key, identity(item)); });
      if (inspect(current, config).gifts.length) state.active = true;
      return current;
    }
    async function reconcile() {
      var cart = await read();
      for (var count = 0; count < 12; count += 1) {
        var action = plan(cart, config, state);
        if (!action) return cart;
        if (action.type === 'reject') {
          state.blocked = fingerprint(cart, config);
          io.status('unavailable');
        }
        try {
          giftOutcomeUnknown = true;
          if (action.type === 'add') {
            var properties = {};
            properties[config.markerKey] = config.markerValue;
            await io.post('add', { items: [{ id: config.giftVariant, quantity: 1, properties: properties }] });
          } else {
            await io.post('change', { id: action.item.key, quantity: action.quantity });
          }
        } catch (error) {
          if (action.type === 'add') state.blocked = fingerprint(cart, config);
          cart = await read();
          if (action.type === 'add' && !inspect(cart, config).gifts.length) {
            io.status('unavailable');
            return cart;
          }
          if (action.type !== 'add') throw error;
        }
        cart = await read();
      }
      throw new Error('Cart could not settle');
    }
    function serial(work) {
      var task = function () { return io.lock ? io.lock(work) : work(); };
      var result = tail.then(task, task);
      tail = result.catch(function () {});
      return result;
    }
    async function changeTarget(key, quantity) {
      var known = remembered.get(key);
      var cart = await read();
      var item = cart.items.find(function (line) { return line.key === key; });
      if (!item && known) {
        var matches = cart.items.filter(function (line) { return identity(line) === known; });
        if (matches.length === 1) item = matches[0];
      }
      if (!item) return null;
      if (inspect(cart, config).gifts.indexOf(item) !== -1) {
        if (Number(quantity) === 0) { state.declined = true; io.save(); }
        quantity = Math.min(1, Number(quantity));
      }
      return { id: item.key, quantity: quantity };
    }
    return { read: read, reconcile: reconcile, serial: serial, changeTarget: changeTarget, current: function () { return current; }, invalidate: function () { giftOutcomeUnknown = true; }, unsafe: function () { return giftOutcomeUnknown || !!(current && plan(current, config, state) && inspect(current, config).gifts.length); } };
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { giftCovered: giftCovered, identity: identity, inspect: inspect, fingerprint: fingerprint, plan: plan, createEngine: createEngine }; return; }
  var node = document.getElementById('ThreadstrongFreeperkConfig');
  if (!node || window.theme.freeperk) return;
  var config = JSON.parse(node.textContent);
  var storageKey = 'threadstrong-freeperk-v1';
  var state = { active: false, declined: false, blocked: null, until: 0 };
  try {
    var saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
    if (saved && saved.until > Date.now()) Object.assign(state, saved);
  } catch (error) {}
  var entry = new URL(location.href).searchParams.get('ts_promo') === 'freeperk';
  var returnKey = storageKey + '-return';
  try {
    // Shopify can discard the nested query. Restore it once in this tab, before cart work.
    var pendingValue = sessionStorage.getItem(returnKey);
    sessionStorage.removeItem(returnKey);
    var pendingReturn = JSON.parse(pendingValue || 'null');
    if (!entry && pendingReturn && typeof pendingReturn.url === 'string' &&
        Number.isFinite(pendingReturn.savedAt) && pendingReturn.savedAt <= Date.now() &&
        Date.now() - pendingReturn.savedAt < 120000 && /^\/(?!\/)/.test(pendingReturn.url) &&
        !/[\\\u0000-\u001f\u007f]/.test(pendingReturn.url)) {
      var restored = new URL(pendingReturn.url, location.origin);
      var currentUrl = new URL(location.href);
      var queryMatches = Array.from(currentUrl.searchParams.keys()).every(function (key) {
        return JSON.stringify(currentUrl.searchParams.getAll(key)) === JSON.stringify(restored.searchParams.getAll(key));
      });
      if (!queryMatches && document.referrer) {
        // The live discount route can escape each percent once more. Accept only that
        // exact transform, with the original same-product campaign as the referrer.
        var referrer = new URL(document.referrer);
        var fromCampaign = referrer.origin === location.origin && referrer.pathname === restored.pathname && referrer.searchParams.get('ts_promo') === 'freeperk';
        referrer.searchParams.delete('ts_promo');
        referrer.searchParams.delete('discount');
        var nativeReturn = new URL(restored.href);
        nativeReturn.search = restored.search.replace(/%/g, '%25');
        queryMatches = fromCampaign && referrer.search === restored.search && Array.from(currentUrl.searchParams.keys()).every(function (key) {
          return JSON.stringify(currentUrl.searchParams.getAll(key)) === JSON.stringify(nativeReturn.searchParams.getAll(key));
        });
      }
      if (restored.origin === location.origin && restored.pathname === location.pathname &&
          queryMatches && (!currentUrl.hash || currentUrl.hash === restored.hash) &&
          !restored.searchParams.has('ts_promo') && !restored.searchParams.has('discount') &&
          restored.href !== location.href) {
        location.replace(restored.pathname + restored.search + restored.hash);
        return;
      }
    }
  } catch (error) {}
  if (entry) Object.assign(state, { active: true, declined: false, blocked: null, until: Date.now() + 86400000 });
  function save() { try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (error) {} }
  if (entry) save();
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  if (entry) {
    // Capture campaign intent before Shopify's discount redirect drops nested query parameters.
    // Do not touch cart contents until the native code application has completed.
    var destination = new URL(location.href);
    destination.searchParams.delete('ts_promo');
    destination.searchParams.delete('discount');
    // Never hand Shopify a protocol-relative path, even on an unusual entry URL.
    if (/^\/\//.test(destination.pathname)) destination = new URL(root, location.origin);
    try { sessionStorage.setItem(returnKey, JSON.stringify({ url: destination.pathname + destination.search + destination.hash, savedAt: Date.now() })); } catch (error) {}
    location.replace(root + 'discount/FREEPERK?redirect=' + encodeURIComponent(destination.pathname + destination.search));
    return;
  }
  var busy = 0;
  var bypass = new WeakSet();
  var checkoutPending = false;
  var fallbackScheduled = false;
  var relevant = function () { return state.active || config.hasGift || !!(engine.current() && inspect(engine.current(), config).gifts.length); };
  function status(key) {
    document.querySelectorAll('[data-freeperk-status]').forEach(function (el) { el.textContent = key ? config.messages[key] : ''; el.hidden = !key; });
  }
  function setBusy(delta) {
    busy += delta;
    document.querySelectorAll('.additional-checkout-buttons, .shopify-payment-button').forEach(function (el) { el.inert = relevant() && (busy > 0 || engine.unsafe()); });
    document.querySelectorAll('[data-freeperk-guarded]').forEach(function (button) { if (relevant()) button.disabled = busy > 0 || engine.unsafe(); });
    document.querySelectorAll('[data-freeperk-initial-warning]').forEach(function (el) { el.hidden = !!engine.current() && !engine.unsafe(); });
    document.documentElement.toggleAttribute('data-freeperk-busy', busy > 0 && relevant());
  }
  async function jsonRequest(kind, body) {
    var response = await fetch(root + 'cart/' + kind + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    var data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Cart update failed');
    return data;
  }
  var engine = createEngine(config, {
    read: async function () {
      var response = await fetch(root + 'cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart could not be checked');
      return response.json();
    },
    post: jsonRequest,
    status: status,
    save: save,
    lock: function (work) { return navigator.locks ? navigator.locks.request(storageKey, work) : work(); }
  }, state);
  async function settle() {
    try { var cart = await engine.reconcile(); status(state.blocked === fingerprint(cart, config) ? 'unavailable' : null); save(); return cart; }
    catch (error) { status('retry'); throw error; }
  }
  function refresh() { document.dispatchEvent(new CustomEvent('cart:build')); }
  function run(work) {
    setBusy(1);
    return engine.serial(work).finally(function () { setBusy(-1); });
  }
  function fallback() {
    if (!relevant() || busy || fallbackScheduled || checkoutPending) return;
    fallbackScheduled = true;
    Promise.resolve().then(function () {
      fallbackScheduled = false;
      return run(settle).then(refresh).catch(function () {});
    });
  }
  async function request(url, init) {
    if (!relevant()) return fetch(url, init);
    if (checkoutPending) throw new Error(config.messages.retry);
    return run(async function () {
      var path = new URL(url, location.origin).pathname;
      var next = Object.assign({}, init);
      if (/\/cart\/change\.js$/.test(path)) {
        var body = JSON.parse(init.body);
        var target = await engine.changeTarget(body.id, body.quantity);
        if (!target) { status('retry'); return new Response(JSON.stringify(await engine.read()), { headers: { 'Content-Type': 'application/json' } }); }
        next.body = JSON.stringify(Object.assign({}, body, target));
      }
      var response;
      if (relevant()) engine.invalidate();
      try { response = await fetch(url, next); }
      catch (error) { if (relevant()) { try { await settle(); refresh(); } catch (ignored) {} } throw error; }
      if (!response.ok) { try { await settle(); } catch (ignored) {} return response; }
      if (!relevant()) return response;
      var cart;
      try { cart = await settle(); }
      catch (error) { return response; }
      if (/\/cart\/(change|update)\.js$/.test(path)) return new Response(JSON.stringify(cart), { status: response.status, headers: { 'Content-Type': 'application/json' } });
      return response;
    });
  }
  window.theme.freeperk = { request: request, reconcile: function () { return run(settle); }, inspect: function () { return engine.current(); } };
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-freeperk-decline]')) { state.declined = true; save(); }
  });
  document.addEventListener('product-form:cart:request', function (event) {
    if (event.defaultPrevented || !relevant()) return;
    event.preventDefault();
    request(root + 'cart/add.js', event.detail.config).then(async function (response) {
      var data = await response.json();
      if (!response.ok) throw data;
      event.detail.resolve(data);
    }).catch(event.detail.reject);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented || bypass.has(form)) return;
    var action = new URL(form.action, location.origin);
    if (action.origin !== location.origin) return;
    if (/\/cart\/add\/?$/.test(action.pathname) && relevant()) {
      event.preventDefault();
      var submitter = event.submitter;
      var data = new FormData(form, submitter);
      if (submitter) submitter.disabled = true;
      request(root + 'cart/add.js', { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }).then(async function (response) {
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        var destination = data.get('return_to');
        var target = destination ? new URL(destination, location.origin) : new URL(root + 'cart', location.origin);
        location.assign(target.origin === location.origin ? target.href : root + 'cart');
      }).catch(function (error) { status('retry'); alert(error.message || config.messages.retry); }).finally(function () { if (submitter) submitter.disabled = false; });
      return;
    }
    if (!/\/cart\/?$/.test(action.pathname) || !event.submitter || event.submitter.name !== 'checkout' || !relevant()) return;
    var terms = form.querySelector('.cart__terms-checkbox');
    if (terms && !terms.checked) return;
    event.preventDefault();
    if (checkoutPending) return;
    checkoutPending = true;
    var button = event.submitter;
    var submitted = false;
    function replay() {
      var quantities = Array.from(form.querySelectorAll('[name="updates[]"]')).filter(function (input) { return !input.disabled; });
      quantities.forEach(function (input) { input.disabled = true; });
      var replayEvent = null;
      function record(event) { replayEvent = event; }
      form.addEventListener('submit', record, { once: true });
      bypass.add(form);
      button.disabled = false;
      try { form.requestSubmit(button); submitted = !!replayEvent && !replayEvent.defaultPrevented; }
      finally {
        bypass.delete(form);
        form.removeEventListener('submit', record);
        quantities.forEach(function (input) { input.disabled = false; });
      }
    }
    run(async function () {
      try { await settle(); }
      catch (error) {
        var cart = engine.current();
        if (engine.unsafe() || (cart && inspect(cart, config).gifts.length)) throw error;
      }
      replay();
    }).catch(function () {}).finally(function () {
      if (!submitted) { checkoutPending = false; button.classList.remove('btn--loading'); }
    });
  });
  ['cart:updated', 'ajaxProduct:added', 'product-form:cart:update', 'cart:open', 'drawerOpen'].forEach(function (name) { document.addEventListener(name, fallback); });
  window.addEventListener('pageshow', function () { checkoutPending = false; fallback(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) fallback(); });
  window.addEventListener('storage', function (event) {
    if (event.key !== storageKey) return;
    try { var saved = JSON.parse(event.newValue); if (saved && saved.until > Date.now()) Object.assign(state, saved); } catch (error) {}
    fallback();
  });
  fallback();
})();
